<template>
  <div class="CurrencyFormatter">
    <div class="CurrencyFormatter__item">
      <span>{{ formattedValue }}</span>
    </div>
  </div>
</template>

<script setup>
import { computed } from 'vue'

const props = defineProps({
  value: {
    type: Number,
    required: true
  },
  currency: {
    type: String,
    required: true,
    default: 'CHF'
  },
  hasNegativeSign: {
    type: Boolean,
    default: false
  },
  compact: {
    type: Boolean,
    default: false
  }
})

const formattedValue = computed(() =>
  formatNumberWithMinusSign(
    props.value,
    props.currency === 'CHF' ? 'CHF' : '€',
    props.currency === 'CHF' ? 'de-CH' : 'de-DE'
  )
)

function formatNumberWithMinusSign(number, currency, locale) {
  const numberFormat = new Intl.NumberFormat(locale, {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2
  })

  let formattedNumber = numberFormat.format(Math.abs(number))

  if (props.compact && formattedNumber.toString().includes(',00')) {
    formattedNumber = formattedNumber.toString().replace(',00', '')
  }

  if (props.hasNegativeSign && props.currency === 'EUR') {
    // if it has negative sign to true it sets value like this example -10.000.00€
    return `-${formattedNumber} ${currency} `
  } else if (props.currency === 'EUR') {
    // if the currency is EUR sets value like this example 10000€
    return `${formattedNumber} ${currency} `
  } else if (props.hasNegativeSign && props.currency === 'CHF') {
    // if it has negative sign to true it sets value like this example CHF -10’000.00
    return `${currency} -${formattedNumber}`
  } else if (props.currency === 'CHF') {
    // if the currency is CHF sets value like this example CHF 10’000.00
    return `${currency} ${formattedNumber}`
  }
}
</script>

<style scoped lang="postcss">
.CurrencyFormatter {
  display: inline-flex;
  justify-content: flex-end;
  min-width: max-content;
  color: inherit;
  text-decoration: inherit;
  &__item {
    display: flex;
    gap: var(--wa-space-3xs);
  }
}
</style>
